import React, { useContext, useEffect, useState } from 'react';
import { IProps } from './types';
import { UnderlineIcon } from '@assets/icons/underlineIcon';
import Tooltip from '@components/Tooltip';
import * as S from './styles';
import { ITextAttributes } from 'routes/private/Editor/types';
import { Context } from "routes/private/Editor/Context";
import { findElementById, findCommonAttributeValue } from "@utils/editor";


const FontUnderlineCommandOption : React.FC<IProps> = () => {
  let { editorStatus, data, onCommandChange} = useContext(Context);
  const [isSelected, setIsSelected]= useState(false);

  useEffect(() => {
    const fontUnderline = findCommonAttributeValue(editorStatus.selectedElementsId, data, "fontUnderline", "Text", editorStatus.textSelectionInformation);
    const someOneNotUnderline = !fontUnderline;
    setIsSelected(!someOneNotUnderline);
  }, [editorStatus.selectedElementsId.length, editorStatus.selectedElementsId[0], data, editorStatus.textSelectionInformation]);

  const SetFontUnderline = () => {  
    setIsSelected(!isSelected);
    onCommandChange("fontUnderline", !isSelected);          
  }

  return (
    <S.Root>
      <Tooltip tip={"Underline"}>
        <S.ButtonContainer onClick={SetFontUnderline} isSelected={isSelected}>
          <UnderlineIcon/>
        </S.ButtonContainer>
      </Tooltip>
    </S.Root>
  );
}

export default FontUnderlineCommandOption;